import React from 'react';

// The one spinner shown while a page is being reached: the auth check in
// App.jsx and the lazy-route Suspense fallback in AuthenticatedRoutes.jsx.
//
// These were two separate inline copies at different heights (100vh and 50vh),
// so on a cold load the spinner appeared centered in the full viewport and then
// visibly jumped to a new position when the auth gate handed off to Suspense --
// one of the stages that made the app look like it loaded more than once.
// Both now render this, so the handoff is invisible.
export default function PageSpinner({ minHeight = '60vh' }) {
  return (
    <div
      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight }}
      aria-label="Loading"
      role="status"
    >
      <div style={{
        width: '40px',
        height: '40px',
        border: '4px solid var(--border-color)',
        borderTop: '4px solid var(--primary-color)',
        borderRadius: 0,
        animation: 'spin 1s linear infinite'
      }} />
    </div>
  );
}
